import { render, staticRenderFns } from "./StoreRoleInfo.vue?vue&type=template&id=511d68a3&scoped=true&"
import script from "./StoreRoleInfo.vue?vue&type=script&lang=js&"
export * from "./StoreRoleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d68a3",
  null
  
)

export default component.exports